import * as React from 'react';
import { ConfirmationBox } from './ConfirmationsBoxWrapper/ConfirmationBox';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfirmationBoxState } from 'src/domains/players/state/ConfirmationBoxState';

export const ConfirmationsBoxWrapper = observer('ConfirmationsBoxWrapper', () => {
    const common = useCommon();
    const { confirmationForView } = ConfirmationBoxState.get(common);

    if (confirmationForView === null) {
        return null;
    }

    const { title, message, onConfirm, onReject } = confirmationForView;

    return (
        <ConfirmationBox
            message={message}
            title={title}
            onConfirm={onConfirm}
            onReject={onReject}
        />
    );
});
